<script setup>

import {useCheckFieldsForData} from "@/composables/common/useCheckFieldsForData";
import {ref, computed} from 'vue';

const tileColour = computed(() => {

  return props.tileColor

})

const props = defineProps ({

  viewModel: {},
  tileSelectionModel: {},
  validationProp: Boolean,
  useIcons: {type:Boolean, default: true},
  tileColor: {type: String, default: '#c9c8c7'},
})

const emits = defineEmits(['select'])

</script>
<template class="cmp-section-tile">
  <div class="cmp-section-tile_tile" :class="{'cmp-section-tile_active' : props.tileSelectionModel}"
       @click="emits('select')">
    <div class=" cmp-section-tile_icon"><slot name="icon"></slot></div>
    <div class="cmp-section-tile_tile-title"><slot name="title"></slot>
      <div class="cmp-section-tile_tile-description"><slot name="description"></slot></div>
    </div>
    <div>
      <img v-if="!props.tileSelectionModel" src="@/assets/icons/arrow_down.png" class="cmp-section-tile_lower-icon-button">
      <img v-else src="@/assets/icons/arrow_down_open.png" class="cmp-section-tile_lower-icon-button-open">
      <img v-if="useCheckFieldsForData(props.viewModel) && props.validationProp && !props.tileSelectionModel"
           src="@/assets/icons/shield_success.png"
           title="Fields have data and any validation is correct"
           class="cmp-section-tile_success-icon-button">
      <div v-if="!props.validationProp && props.useIcons" class="cmp-section-tile_upper-icon-button">
        <img src="@/assets/icons/alert.png" title="Please Correct Any Validation Errors">
      </div>
      <span v-if="!props.validationProp && props.useIcons" class="cmp-section-tile_validation-message">Required Fields</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.cmp-section-tile {

  &_tile {
    position: relative;
    height: 70px;
    width: auto;
    border-radius: 6px;
    //background-image: linear-gradient(0deg,  v-bind(tileColour), #173746);
    background: v-bind(tileColour);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
    gap: 20px;
    cursor: pointer;
  }

  &_icon {
    color: white;
  }

  &_tile-title {
    color: white;
    font-size: 15px;
    font-weight: bold;
  }

  &_tile-description {
    font-size: 11px;
    font-weight: normal;
    width: max-content;
  }

  &_tile:hover, &_active {
    //background: v-bind(tileColour);
    background-image: linear-gradient(0deg, rgba(2, 2, 2, 0.35),  v-bind(tileColour));
  }

  &_lower-icon-button {
    position: absolute;
    bottom: 0px;
    right: 6px;
    cursor: pointer;
  }

  &_success-icon-button {
    position: absolute;
    top: 2px;
    right: 6px;
    cursor: default;
  }

  &_lower-icon-button-open {
    position: absolute;
    height: 45px;
    width: 45px;
    right: -1px;
    cursor: pointer;
  }

  &_upper-icon-button {
    position: absolute;
    top: 4px;
    right: 10px;
    cursor: default;
  }

  &_validation-message {
    font-size: 10px;
    color: #f4db16;
    position: absolute;
    bottom: 2px;
    left: 10px;
  }

}

</style>
